var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77148 0C6.89148 0 5.15148 0.66 3.77148 1.76C1.93148 3.22 0.771484 5.48 0.771484 8C0.771484 9.5 1.19148 10.92 1.93148 12.12C3.31148 14.44 5.85148 16 8.77148 16C10.7915 16 12.6315 15.26 14.0315 14C14.6515 13.48 15.1915 12.84 15.6115 12.12C16.3515 10.92 16.7715 9.5 16.7715 8C16.7715 3.58 13.1915 0 8.77148 0ZM12.9115 7.14L8.65148 11.08C8.37148 11.34 7.99146 11.48 7.63146 11.48C7.25146 11.48 6.87146 11.34 6.57146 11.04L4.59148 9.06C4.01148 8.48 4.01148 7.52 4.59148 6.94C5.17148 6.36 6.13148 6.36 6.71148 6.94L7.67148 7.9L10.8715 4.94C11.4715 4.38 12.4315 4.42 12.9915 5.02C13.5515 5.62 13.5115 6.58 12.9115 7.14Z",
    fill: "#00D220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.2c268bf5a3cda77dcff66fdf305ece9c.svg";
export { ForwardRef as ReactComponent };